export type DocumentFileType = "folder" | "image" | "pdf" | "word" | "sheet" | "file";

export interface DocumentFolderItem {
    id: number;
    name: string;
    code?: string;
    path?: string;
    fileCount: number;
    sizeLabel: string;
    selected?: boolean;
    description?: string;
    recentDate?: string;
    trdName?: string;
}

export const normalizeText = (value: string) => value.toLowerCase().trim();

const normalizeRecord = (record: any): any => record?.DataBeanProperties ?? record ?? {};

const formatRecordDate = (value?: string) => {
    if (!value) return "";

    const date = new Date(value.replace(" ", "T"));
    if (Number.isNaN(date.getTime())) return value;

    return date.toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" });
};

export const mapFileRecordToFolderItem = (record: any): DocumentFolderItem => {
    const data = normalizeRecord(record);
    const id = Number(data.IDDOCFileRecord ?? 0);

    return {
        id,
        name: data.Name ?? `Expediente ${id}`,
        code: data.TRDJsonCode ?? data.Code ?? `${id}`.padStart(2, "0"),
        path: data.TRDName,
        fileCount: 0,
        sizeLabel: data.TRDName ?? "",
        description: data.Description,
        recentDate: formatRecordDate(data.Since ?? data.OpenDate),
        trdName: data.TRDName,
    };
};
